import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=1d5e6db3&scoped=true&"
import script from "./BaseSwitch.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseSwitch.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=1d5e6db3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e6db3",
  null
  
)

export default component.exports